import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Input from '../../../../Components/Forms/Input';
import { vatPattern, useSettings } from '../../Validate';

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(auto-fit, 50px);
  grid-gap: 20px;
`;

const Conference = ({ settings, setValues }) => {
  const { values, handleChange } = useSettings(settings, setValues);
  return (
    <Container>
      <Input
        label="Moms (%)"
        type="text"
        name="vat"
        value={values.vat}
        onChange={handleChange}
        pattern={vatPattern}
        required
      />
    </Container>
  );
};

Conference.propTypes = {
  settings: PropTypes.shape({
    vat: PropTypes.string
  }).isRequired,
  setValues: PropTypes.func.isRequired
};

export default Conference;
